import { useEffect } from "react";

/**
 * Injects the Google Search Console verification <meta> tag if the env var
 * `REACT_APP_GSC_VERIFICATION` is configured. Set the value to the contents of
 * `content="..."` from the Search Console "HTML tag" verification method.
 * Idempotent: re-mounts won't duplicate the tag.
 */
export default function SearchConsoleMeta() {
  useEffect(() => {
    const content = process.env.REACT_APP_GSC_VERIFICATION || "";
    if (!content) return;
    const id = "gsc-verification";
    if (document.getElementById(id)) return;
    const m = document.createElement("meta");
    m.id = id;
    m.name = "google-site-verification";
    m.content = content;
    document.head.appendChild(m);
  }, []);
  return null;
}
